import React from 'react';

import { Container, Typography, makeStyles } from '@material-ui/core';

import { ReactComponent as IconCheck } from '../../assets/images/ic-check.svg';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => {
  return {
    buttonConfirm: {
      fontWeight: '500',
      marginBottom: '16px',
      marginTop: '35px',
      padding: '11px 20px',
    },
    emptyFeatureContainer: {
      height: '18px',
      marginBottom: '10px',
    },
    generalConainer: {
      maxWidth: '296px',
      padding: '0px 30px',
    },
    listContainer: {
      alignItems: 'flex-start',
      display: 'flex',
      justifyContent: 'start',
      marginBottom: '10px',
    },
    listImage: {
      fill: theme.palette.primary.main,
      height: 'auto',
      marginRight: '8px',
      marginTop: '2px',
      width: '16px',
    },
    listLastContainer: {
      marginBottom: '0px',
    },
    listParentContainer: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '0px',
      maxWidth: '232px',
      padding: '0px 0px',
    },
    listText: {
      color: '#FFFFFF',
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '18px',
      textAlign: 'left',
    },
    priceDescriptionContainer: {
      marginBottom: '20px',
      minHeight: '75px',
    },
    priceDescriptionText: {
      color: '#999',
      display: 'block',
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '18px',
      marginBottom: '16px !important',
      textAlign: 'center',
    },
    priceDetailText: {
      color: '#FFF',
      display: 'block',
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '24px',
      marginBottom: '15px !important',
      textAlign: 'center',
    },
    priceText: {
      color: theme.palette.primary.main,
      fontSize: '50px',
      fontWeight: '500',
      lineHeight: '56px',
      marginBottom: '5px !important',
    },
    priceTextDefaultColor: {
      color: '#2AAAE2 !important',
    },
    title: {
      color: '#FFF',
      fontSize: '20px',
      fontWeight: '600',
      lineHeight: '24px',
      marginBottom: '20px !important',
    },
  };
});

export default ({
  title,
  price,
  shouldUseDefaultPriceColor,
  priceDetail,
  description,
  featureList = [],
  onClickConfirm,
  hideDetail,
  buttonText = 'Confirm Package',
  maxFeatureList,
}) => {
  const classes = useStyles();

  const handleClickConfirm = () => {
    if (onClickConfirm && typeof onClickConfirm === 'function') onClickConfirm();
  };

  const priceClasses = [classes.priceText];
  if (shouldUseDefaultPriceColor) priceClasses.push(classes.priceTextDefaultColor);

  const emptyListCount = maxFeatureList - featureList?.length || 0;
  const emptyFeatures = Array.from({ length: emptyListCount > 0 ? emptyListCount : 0 }, (value, index) => ({
    id: `${title}_empty_list_${index}`,
  }));

  return (
    <Container className={classes.generalConainer}>
      <Typography className={classes.title} variant="h2">
        {title}
      </Typography>

      <Typography className={priceClasses.join(' ')} variant="h4">
        {price}
      </Typography>

      <Typography className={classes.priceDetailText} variant="body1">
        {priceDetail}
      </Typography>

      <div className={classes.priceDescriptionContainer}>
        <Typography className={classes.priceDescriptionText} variant="body1">
          {description}
        </Typography>
      </div>

      {!hideDetail && (
        <>
          <div className={classes.listParentContainer}>
            {/* List */}
            {featureList.map((feature) => (
              <div key={`${feature.id}`} className={classes.listContainer}>
                <IconCheck className={classes.listImage} />
                {/* <img className={`${classes.listImage}`} src={IconBlueCheck} alt="blue checklist" /> */}
                <Typography className={classes.listText}>{feature.text}</Typography>
              </div>
            ))}

            {/* Empty List */}
            {emptyFeatures.map((data) => {
              return <div key={data.id} className={classes.emptyFeatureContainer} />;
            })}
          </div>

          {/* Button */}
          <div>
            <LoadingButton variant="contained" color="primary" onClick={handleClickConfirm} className={classes.buttonConfirm}>
              {buttonText}
            </LoadingButton>
          </div>
        </>
      )}
    </Container>
  );
};
